import React, { useEffect, useState } from "react";
import TimeField from 'react-simple-timefield';

import APointIco from "../../../../images/APointIco.svg"
import orderIco from "../../../../images/orderIco.svg"
import separatorLine from "../../../../images/separatorLine.svg"
import AddIco from "../../../../images/AddIco.svg"
import commentIco from "../../../../images/commentIco.svg"

import geoIco from "../../../../images/geoIco.svg"
import deleteIco from "../../../../images/deleteIco.svg"
import RouteCard from "../../../RouteCard/RouteCard";


function OrderCreationSecondStep({ inputs, setInputs, handleCreateApplic, setIsPopupOpened }) {
    const [timeFrom, setTimeFrom] = useState('00:00')

    const onTimeFromChange = (e, time) => {
        console.log(e)
        setTimeFrom(e.target.value)
    }

    const [timeTo, setTimeTo] = useState('00:00')

    const onTimeToChange = (e, time) => {
        setTimeTo(time)
    }

    const [loadAddreses, setLoadAddreses] = useState(inputs.loadingPointsArray)

    const [unloadAddreses, setUnloadAddreses] = useState(inputs.unloadingPointsArray)

    const handleDeleteLoadCard = (id) => {
        setShouldCreate(false);
        setLoadAddreses(loadAddreses.filter((card) => card.pointId !== id));
    }
    const handleAddLoadCard = () => {
        setShouldCreate(false);
        setLoadAddreses(prevItems => [...prevItems, {
            pointId: loadAddreses.length + 1,
            adress: '',
            timeFrom: '',
            timeTo: ''
        }])
    }

    const handleDeleteUnloadCard = (id) => {
        setShouldCreate(false);
        setUnloadAddreses(unloadAddreses.filter((card) => card.pointId !== id));
    }
    const handleAddUnloadCard = () => {
        setShouldCreate(false);
        setUnloadAddreses(prevItems => [...prevItems, {
            pointId: unloadAddreses.length + 1,
            adress: '',
            timeFrom: '',
            timeTo: ''
        }])
    }

    const [isTimeActive, setIsTimeActive] = useState(false)
    const [isRouteActive, setIsRouteActive] = useState(false)
    const [isLoadingPointActive, setIsLoadingPointActive] = useState(false)
    const [isContactActive, setIsContactActive] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Обновляем состояние для измененного поля
        setInputs({
            ...inputs,
            [name]: value
        });

        checkIsFormValid(name, value);
    }

    const handleChangeRadio = (e) => {
        const { name, value, id } = e.target;
        if (name === 'route') {
            if (id === 'order') {
                setLoadAddreses([
                    {
                        pointId: 1,
                        adress: '',
                        timeFrom: '',
                        timeTo: ''
                    }
                ])
                setIsAdressAValid(false)
                setIsTimeValid(false)
            } else if (id === 'input') {
                setLoadAddreses([])
            }
        } else if (name === 'contact') {
            if (id === 'order') {
                setInputs({
                    ...inputs,
                    contactName: '',
                    contactNumber: ''
                })
            }
        }
        checkIsFormValid(name, e.target);
    }

    const handleChangeLoadPointAdress = (e) => {
        const { name, value } = e.target


        let updatedPoints = loadAddreses.map(item => {
            if (item.pointId === 1) {
                return {
                    ...item,
                    adress: value
                }
            } else {
                return item
            }
        })
        setLoadAddreses(updatedPoints)
        checkIsFormValid(name, value);
    }
    const handleChangeLoadPointTimeFrom = (e) => {
        const { name, value } = e.target
        console.log(timeFrom)
        let updatedPoints = loadAddreses.map(item => {
            if (item.pointId === 1) {
                return {
                    ...item,
                    timeFrom: value
                }
            } else {
                return item
            }
        })
        setLoadAddreses(updatedPoints)
    }
    const handleChangeLoadPointTimeTo = (e) => {
        const { name, value } = e.target
        let updatedPoints = loadAddreses.map(item => {
            if (item.pointId === 1) {
                return {
                    ...item,
                    timeTo: value
                }
            } else {
                return item
            }
        })
        setLoadAddreses(updatedPoints)
    }
    console.log(loadAddreses)
    console.log(unloadAddreses)

    const [shouldCreate, setShouldCreate] = useState(false);

    const handleSetArrays = (e) => {
        e.preventDefault();
        setInputs({
            ...inputs,
            loadingPointsArray: loadAddreses,
            unloadingPointsArray: unloadAddreses
        })
        console.log(inputs)
        setShouldCreate(true); // Устанавливаем флаг для вызова handleCreate
    }

    const handleCreate = () => {
        if (inputs.loadingPointsArray.length !== 0) {
            handleCreateApplic()
        }
    }

    useEffect(() => {
        if (shouldCreate) {
            handleCreate();
            setIsPopupOpened(true)
            setShouldCreate(false); // Сбрасываем флаг после вызова handleCreate
        }
    }, [shouldCreate]); // Срабатывает, когда изменяются shouldCreate

    const [isFormValid, setIsFormValid] = useState(false)
    const [isAdressAValid, setIsAdressAValid] = useState(false)
    const [isTimeValid, setIsTimeValid] = useState(false)
    const [isRouteListValid, setIsRouteListValid] = useState(false)
    const [isContactValid, setIsContactValid] = useState(false)

    const checkIsFormValid = (name, value) => {
        console.log(name, value.checked)
        let result
        switch (name) {
            case 'adress-a':
                if (isLoadingPointActive) {
                    if (!value.length) {
                        setIsFormValid(false)
                        result = false
                    } else {
                        result = true
                    }
                } else {
                    result = true
                }
                setIsAdressAValid(result)
                break;
            case 'time':
                if (isLoadingPointActive) {
                    if (!value.checked) {
                        setIsFormValid(false)
                        result = false
                    } else {
                        result = true
                    }
                } else {
                    result = true
                }
                setIsTimeValid(result)
                break;
            case 'route':
                if (!value.checked) {
                    setIsFormValid(false)
                    result = false
                } else {
                    result = true
                }
                setIsRouteListValid(result)
                break;
            case 'contact':
                if (!value.checked) {
                    setIsFormValid(false)
                    result = false
                } else {
                    result = true
                }
                setIsContactValid(result)
                break;

            default:
                break;
        }
    }

    const [areLoadingPointsValid, setAreLoadingPointsValid] = useState(false)
    const [isContactInfoValid, setIsContactInfoValid] = useState(true)

    const checkLoadingArrayValidity = () => {
        let result
        if (isRouteActive) {
            if (loadAddreses.length === 0 || loadAddreses[0]?.adress === '') {
                setIsFormValid(false)
                result = false
            } else {
                result = true
            }
        } else {
            if (isAdressAValid && isTimeValid) {
                result = true
            } else {
                result = false
            }
        }
        setAreLoadingPointsValid(result)
        checkCombinedInputValidity()
    }

    const checkContactInfoValidity = () => {
        let result
        if (isContactActive) {
            if (inputs.contactName && inputs.contactNumber) {
                result = true

            } else {
                setIsFormValid(false)
                result = false
            }
        } else {
            result = true
        }
        setIsContactInfoValid(result)
        checkCombinedInputValidity()
    }

    const checkCombinedInputValidity = () => {
        let result
        const combinedValidity = isRouteListValid && isContactValid && areLoadingPointsValid && isContactInfoValid
        result = combinedValidity ? true : false
        setIsFormValid(result)
    }

    useEffect(() => {
        checkCombinedInputValidity();
    })

    useEffect(() => {
        checkLoadingArrayValidity();
    })

    useEffect(() => {
        checkContactInfoValidity();
    })

    useEffect(() => {
        if (loadAddreses.length !== 0) {
            setIsRouteActive(true)
            setIsRouteListValid(true)
        }
        if (inputs.contactName) {
            setIsContactActive(true)
            setIsContactValid(true)
        } else {
            setIsContactValid(true)
        }
    }, [])

    useEffect(() => {
        checkFrstRndrCombinedInputValidity()
    }, [])


    const checkFrstRndrCombinedInputValidity = () => {
        console.log(inputs.loadingPointsArray.length)
        const combinedValidity = inputs.loadingPointsArray.length !== 0 && isContactInfoValid
        if (combinedValidity) {
            setIsFormValid(true);
        }
    }

    useEffect(() => {
        setInputs({
            ...inputs,
            loadingPointsArray: loadAddreses,
            unloadingPointsArray: unloadAddreses
        })
    }, [loadAddreses, unloadAddreses])

    return (
        <div className="order-creation__step-conatiner">
            <form name="order-creation-2" className="order-creation__form" onSubmit={handleSetArrays} >
                <div className="order-creation__route-container order-creation__container">
                    <h2 className="order-creation__route-container-title order-creation__container-title">Маршрут</h2>
                    <div className="order-creation__route-checkbox-container order-creation__checkbox-container">
                        <label className="order-creation__route-checkbox order-creation__check-label"><input type="radio" required name="route" id="input" className="order-creation__route-checkbox-input order-creation__check-input" onClick={(e) => { setIsRouteActive(true); setIsLoadingPointActive(false); handleChangeRadio(e); }} checked={isRouteActive} />Создать<span className="order-creation__route-checkbox-span order-creation__check-span"></span></label>
                        <label className="order-creation__route-checkbox order-creation__check-label"><input type="radio" required name="route" id="order" className="order-creation__route-checkbox-input order-creation__check-input" onClick={(e) => { setIsRouteActive(false); setIsLoadingPointActive(true); handleChangeRadio(e); }} checked={isLoadingPointActive} />Договорюсь с перевозчиком<span className="order-creation__route-checkbox-span order-creation__check-span"></span></label>

                    </div>
                    {
                        isRouteActive ?
                            <div className="order-creation__route-input-container">
                                <div className="order-creation__route-input-title">
                                    Погрузка
                                </div>
                                <ul className="order-creation__route-list" >
                                    {loadAddreses?.map((adress) => (
                                        <li className="order-creation__card-container" key={adress.pointId || adress.id}>
                                            <RouteCard adress={adress} handleDelete={handleDeleteLoadCard} array={loadAddreses} setArray={setLoadAddreses} setIsValid={setIsRouteListValid} />
                                        </li>
                                    ))}
                                </ul>
                                <button className="order-creation__add-card-button" type="button" onClick={handleAddLoadCard}>Добавить точку <img src={AddIco} alt="" /></button>
                                <div className="order-creation__route-input-title">
                                    Разгрузка
                                </div>
                                <ul className="order-creation__route-list" >
                                    {unloadAddreses?.map((adress) => (
                                        <li className="order-creation__card-container" key={adress.pointId || adress.id}>
                                            <RouteCard adress={adress} handleDelete={handleDeleteUnloadCard} array={unloadAddreses} setArray={setUnloadAddreses} setIsValid={setIsRouteListValid} />
                                        </li>
                                    ))}
                                </ul>
                                <button className="order-creation__add-card-button" type="button" onClick={handleAddUnloadCard}>Добавить точку <img src={AddIco} alt="" /></button>
                            </div>
                            :
                            <>
                            </>
                    }


                </div>
                {
                    isLoadingPointActive &&
                    <>
                        <div className="order-creation__adress-container">
                            <h2 className="order-creation__adress-container-title order-creation__container-title">Точка погрузки:</h2>
                            <div className="order-creation__a-point-container">
                                <img src={APointIco} alt="A" className="order-creation__a-point-icon" />
                                <div className="order-creation__adress-input-container">
                                    <img src={orderIco} alt="ввод" className="order-creation__adress-input-icon" />
                                    <input type="text" name="adress-a" id="adress-a" className="order-creation__adress-input" required onChange={handleChangeLoadPointAdress} />
                                </div>
                            </div>
                        </div>
                        <div className="order-creation__time-container order-creation__container">
                            <h2 className="order-creation__time-container-title order-creation__container-title">Время погрузки:</h2>
                            <div className="order-creation__time-checkbox-container order-creation__checkbox-container">
                                <label className="order-creation__time-checkbox order-creation__check-label"><input type="radio" name="time" id="order" required className="order-creation__time-checkbox-input order-creation__check-input" onClick={(e) => { setIsTimeActive(false); handleChangeRadio(e) }} />Договорюсь с перевозчиком<span className="order-creation__time-checkbox-span order-creation__check-span"></span></label>
                                <label className="order-creation__time-checkbox order-creation__check-label"><input type="radio" name="time" id="input" required className="order-creation__time-checkbox-input order-creation__check-input" onClick={(e) => { setIsTimeActive(true); handleChangeRadio(e) }} />Ввести<span className="order-creation__time-checkbox-span order-creation__check-span"></span></label>
                            </div>
                            {
                                isTimeActive ?
                                    <div className="order-creation__time-input-container">
                                        <input type="time" id="from" className="order-creation__time-input" required placeholder="00:00" onChange={handleChangeLoadPointTimeFrom} />
                                        <img src={separatorLine} alt="--" />
                                        <input type="time" id="to" className="order-creation__time-input" required placeholder="00:00" onChange={handleChangeLoadPointTimeTo} />
                                    </div>
                                    :
                                    <></>
                            }

                        </div>
                    </>
                }
                <div className="order-creation__contact-container order-creation__container">
                    <h2 className="order-creation__contact-container-title order-creation__container-title">Контактное лицо</h2>
                    <div className="order-creation__contact-checkbox-container order-creation__checkbox-container">
                        <label className="order-creation__contact-checkbox order-creation__check-label"><input required type="radio" name="contact" id="order" className="order-creation__contact-checkbox-input order-creation__check-input" onClick={(e) => { setIsContactActive(false); handleChangeRadio(e) }} checked={!isContactActive} />Как в данных профиля<span className="order-creation__contact-checkbox-span order-creation__check-span"></span></label>
                        <label className="order-creation__contact-checkbox order-creation__check-label"><input required type="radio" name="contact" id="input" className="order-creation__contact-checkbox-input order-creation__check-input" onClick={(e) => { setIsContactActive(true); handleChangeRadio(e) }} checked={isContactActive} />Добавить<span className="order-creation__contact-checkbox-span order-creation__check-span"></span></label>
                    </div>
                    {
                        isContactActive ?
                            <div className="order-creation__contact-inputs-container">
                                <p className="order-creation__contact-input-title">Имя:</p>
                                <input type="text" className="order-creation__contact-input" required name="contactName" placeholder={inputs.contactName} onChange={handleChange} />
                                <p className="order-creation__contact-input-title">Номер телефона:</p>
                                <input type="text" className="order-creation__contact-input" required name="contactNumber" placeholder={inputs.contactNumber} onChange={handleChange} />
                            </div>
                            :
                            <></>
                    }

                </div>
                <div className="order-creation__comment-container order-creation__container">
                    <div className="order-creation__comment-container-header">
                        <h2 className="order-creation__comment-container-title order-creation__container-title">Особые требования: </h2>
                    </div>
                    <div className="order-creation__comment-input-container" contentEditable="true" suppressContentEditableWarning={true}>
                        <textarea type="text" className="order-creation__comment-input" cols="40" rows="5" name="specialRequirements" placeholder={inputs.specialRequirements} onChange={handleChange} />
                    </div>
                </div>
                <div className="order-creation__comment-container">
                    <div className="order-creation__comment-container-header">
                        <h2 className="order-creation__comment-container-title order-creation__container-title">Комментарий:</h2>
                    </div>
                    <div className="order-creation__comment-input-container" contentEditable="true" suppressContentEditableWarning={true}>
                        <textarea type="text" className="order-creation__comment-input" cols="40" rows="5" name="comment" placeholder={inputs.comment} onChange={handleChange} />
                    </div>
                </div>
                <button className="order-creation__submit-button" type="submit" disabled={!isFormValid} >Создать заявку</button>
            </form>

        </div>
    )
}

export default OrderCreationSecondStep;